import React, { useEffect, useContext, useState, Suspense } from 'react'
import { Route, BrowserRouter as Router, withRouter, Switch } from 'react-router-dom'
import PrivateRoute from './privateRoute'
import Loaders from '@/custom/components/molecules/Loaders'
import AppointmentManage from '../views/Dashboard/Appointment/AppointmentManage'
import Header from '@/custom/components/molecules/Header'
import Footer from '@/custom/components/molecules/Footer'
import Subscription from '../views/Subscription/index_skyflow'
import Maintanence from '@/product/components/organisms/Maintanence'
import { OemDetails } from '@/views/OemDetails'
import { BrandDetails } from '@/views/BrandDetails'
import { EquipmentListingPage } from '@/views/EquipmentListingPage'
import Checkout from '@/views/Checkout'
import AuctionsList from '@/views/AuctionsList'
// import { AuctionRoom } from '@/views/AuctionRoom'
import { AuctionLot } from '@/views/AuctionLot'
import ValuationServices from '@/views/ValuationServices'
import NewEquipmemt from '@/views/NewEquipment'
import ContactUs from '@/views/Static/ContactUs'
import TermsOfUse from '@/views/Static/TermsOfUse'
import PrivacyPolicy from '@/views/Static/PrivacyPolicy'
import AboutUs from '@/views/Static/AboutUs'
import MerchantSectionDash from '@/views/MerchantSectionDash'
import { SpinnerLoader } from '@/custom/components/molecules/Loaders/SpinnerLoader'

const Login = React.lazy(() => import('@/views/Login/login'))
const Home = React.lazy(() => import('@/views/Home'))
const MyAuctions = React.lazy(() => import('@/views/Dashboard/MyAuctions'))
const DashboardInitial = React.lazy(() => import('@/views/Dashboard/MyAuctions'))
const LiveAuction = React.lazy(() => import('@/views/ProductView/LiveAuction'))
const CatalogAuction = React.lazy(() => import('@/views/Catalog/terms'))

const Registration = React.lazy(() => import('@/views/Registration/multiform'))

const ErrorPage = React.lazy(() => import('@/views/ErrorPage'))
const Auction = React.lazy(() => import('@/views/Auction'))
// ==========================
// import PaymentSuccess from '@/views/Dashboard/PaymentSuccess'
const ForgotPassword = React.lazy(() => import('@/views/ForgotPassword'))
const ResetPassword = React.lazy(() => import('@/views/ResetPassword'))
const Search = React.lazy(() => import('@/views/Search'))

const Profile = React.lazy(() => import('@/views/Dashboard/Profile/index'))
const ChangePassword = React.lazy(() => import('@/views/Dashboard/Profile/ChangePassword'))
const MyInvoices = React.lazy(() => import('@/views/Dashboard/MyInvoices'))
const MyDeposits = React.lazy(() => import('@/views/Dashboard/MyDeposits'))
const MyTransactions = React.lazy(() => import('@/views/Dashboard/MyTransactions'))
const AuctionPaymentHistory = React.lazy(() => import('@/views/Dashboard/AuctionPaymentHistory'))
const AuctionTransactions = React.lazy(() => import('@/views/Dashboard/AuctionTransactions'))
const BidderUnderTaking = React.lazy(() => import('@/views/Dashboard/BidderUnderTaking'))
const Callback = React.lazy(() => import('@/views/Dashboard/Callback'))
// const ReinitsateLogs = React.lazy(() => import('@/views/Dashboard/ReinitsateLogs'))
const Invoice = React.lazy(() => import('@/views/Invoice'))
const DepositInvoice = React.lazy(() => import('@/views/DepositInvoice'))

// const ProductViewInvite = React.lazy(() => import('@/views/ProductView/ProductView_Invite'))
const Cart = React.lazy(() => import('@/views/Cart'))
const BuynowCart = React.lazy(() => import('@/views/BuyNowCart'))
const PaymentSuccess = React.lazy(() => import('@/views/Dashboard/PaymentSuccess'))
const MyWallet = React.lazy(() => import('@/views/Dashboard/MyWallet'))
const MySubscription = React.lazy(() => import('@/views/Seller/Dashboard/MySubscription'))

const Notifications = React.lazy(() => import('@/views/Dashboard/Notifications'))
const MyAddress = React.lazy(() => import('@/views/Dashboard/MyAddress'))

const BrandStore = React.lazy(() => import('@/views/HeaderPages/BrandStore'))
const EquipmentDynamic = React.lazy(() => import('@/views/HeaderPages/EquipmentDynamic'))
// const MyCard = React.lazy(() => import('@/views/Dashboard/MyCardPaymentMethod'))
// const MyCard = React.lazy(() => import('@/views/Dashboard/MySkyflowCard'))
const MyBank = React.lazy(() => import('@/views/Dashboard/MyBank'))
const ProductViewPage = React.lazy(() => import('@/views/ProductView'))
const AgreementComponent = React.lazy(() => import('@/views/Dashboard/Aggrement'))
const BulkUpload = React.lazy(() => import('@/views/Dashboard/BulkUpload'))
const Message = React.lazy(() => import('@/views/Message'))
const SwitchUser = React.lazy(() => import('@/views/SwitchUser'))
const Routes = () => {
    return (
        <>
            <Suspense
                fallback={
                    <div className="loaderSuspense">
                        <SpinnerLoader />
                    </div>
                }
            >
                <Header />
                <Switch>
                    {/* <Route exact path="/" component={Login} /> */}
                    <Route exact path="/" component={Home} />
                    <Route exact path="/reset_password/:token" component={ResetPassword} />
                    <Route exact path="/search" component={Search} />
                    <Route exact path="/switch" component={SwitchUser} />
                    <PrivateRoute exact path="/callback" component={Callback} />

                    <PrivateRoute exact path="/transactions" component={AuctionTransactions} />
                    <PrivateRoute exact path="/payments/emd" component={AuctionPaymentHistory} />
                    <PrivateRoute exact path="/bidderSign" component={BidderUnderTaking} />
                    <PrivateRoute exact path="/my_agreements" component={AgreementComponent} />
                    <PrivateRoute exact path="/bulkupload" component={BulkUpload} />
                    <PrivateRoute
                        exact
                        path="/account/dashboard"
                        component={MerchantSectionDash}
                    ></PrivateRoute>
                    <Route exact path="/search/:id/:type" component={Search} />
                    <Route exact path="/search/:type" component={Search} />
                    <Route exact path="/liveAuction/:aid/:token" component={LiveAuction} />
                    <Route exact path="/catalog/:aid" component={CatalogAuction} />
                    <Route exact path="/oem/:id/:client_id" component={OemDetails} />
                    <Route exact path="/forgot_password" component={ForgotPassword} />
                    <Route exact path="/watchlist/:type/:token" component={MyAuctions} />
                    <Route exact path="/allbrands" component={BrandDetails}></Route>
                    <Route exact path="/privacy_policy" component={PrivacyPolicy}></Route>
                    <Route exact path="/terms_conditions" component={TermsOfUse}></Route>
                    <Route exact path="/about_us" component={AboutUs}></Route>
                    <Route exact path="/registration/:action" component={Registration}></Route>
                    <PrivateRoute
                        exact
                        path="/checkout/:auction_id"
                        component={Checkout}
                    ></PrivateRoute>
                    <Route exact path="/" component={Login} />
                    <Route exact path="/equipment/sell" component={EquipmentListingPage} />
                    <Route exact path="/equipment/:action" component={EquipmentDynamic} />
                    <Route exact path="/login" component={Login} />
                    <Route exact path="/brand_store" component={BrandStore} />
                    <Route exact path="/newequipment/:id" component={NewEquipmemt} />
                    <Route exact path="/valuations/services" component={ValuationServices} />
                    <Route exact path="/auctionsList" component={AuctionsList} />
                    <Route exact path="/contactUs" component={ContactUs} />
                    {/* <Route exact path="/auction-details" component={AuctionRoom} /> */}
                    <Route exact path="/auction-lot-view" component={AuctionLot} />
                    <PrivateRoute exact path="/dashboard" component={Auction} />
                    <PrivateRoute exact path="/auction" component={Auction} />
                    <Route exact path="/liveAuction/:aid" component={LiveAuction} />
                    {/* =============================== */}
                    <PrivateRoute exact path="/auctions/:type" component={MyAuctions} />
                    <PrivateRoute exact path="/watchlist/:type" component={MyAuctions} />
                    <PrivateRoute exact path="/purchases/:type" component={MyAuctions} />
                    <Route
                        exact
                        path="/paymentStatusCheck/:default/:auction_id"
                        component={PaymentSuccess}
                    />
                    <PrivateRoute exact path="/account/profile" component={Profile} />
                    <PrivateRoute exact path="/account/change" component={ChangePassword} />
                    <PrivateRoute exact path="/account/notifications" component={Notifications} />
                    <PrivateRoute exact path="/account/myaddress" component={MyAddress} />
                    {/* <PrivateRoute exact path="/company_profile" component={CompanyProfile} /> */}
                    <PrivateRoute exact path="/invoices/:action" component={MyInvoices} />
                    <PrivateRoute exact path="/payments/transactions" component={MyTransactions} />
                    {/* <PrivateRoute exact path="/payments/reinstate" component={ReinitsateLogs} /> */}
                    <PrivateRoute exact path="/invoice/:id" component={Invoice} />
                    <PrivateRoute exact path="/depositinvoice/:id" component={DepositInvoice} />
                    <PrivateRoute exact path="/deposits/:action" component={MyDeposits} />
                    {/* <PrivateRoute exact path="/payments/saved_cards" component={MyCard} />
                    <PrivateRoute exact path="/payments/bank_details" component={MyBank} /> */}
                    <PrivateRoute exact path="/wallet" component={MyWallet} />
                    <Route exact path="/productView/:pid" component={ProductViewPage} />
                    <PrivateRoute exact path="/messages" component={Message} />
                    <Route exact path="*" component={ErrorPage} />
                </Switch>
                <Footer />
            </Suspense>
        </>
    )
}
export default withRouter(Routes)
